module.exports = __webpack_public_path__ + "img/Boy_020027.8325ae5d.png";